import api from './index'

export function getMainDisplayList(params = {}) {
  return api.get('/api/v1/main-display', { params })
}

export function createMainDisplay(data) {
  return api.post('/api/v1/main-display', data)
}

export function updateMainDisplay(mainAssetCode, data) {
  return api.put(`/api/v1/main-display/${mainAssetCode}`, data)
}

export function deleteMainDisplay(mainAssetCode) {
  return api.delete(`/api/v1/main-display/${mainAssetCode}`)
}
